// ** React Imports
import { Fragment } from 'react';

// ** Table Columns
import ComponentSpinner from '@components/spinner/Loading-spinner';
import { columns } from './columns';

// ** Third Party Components
import DataTable from 'react-data-table-component';
import { ChevronDown } from 'react-feather';
import ReactPaginate from 'react-paginate';

// ** Reactstrap Imports
import { Card, Row, Col } from 'reactstrap';
import HeaderRoads from './Header';

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss';

const RoadsList = ({ store, data, variables, handleFetching, loading }) => {
  // ** Function in get data on page change
  const handlePagination = (page) => {
    handleFetching({
      id: variables.id,
      input: {
        page: page.selected + 1,
        perPage: variables.input.perPage
      }
    });
  };

  const NoDataRecords = () => {
    return (
      <Row>
        <Col md={12} className="text-align-center mt-4 mb-4">
          No hay registros que mostrar
        </Col>
      </Row>
    );
  };

  const CustomPagination = () => {
    return (
      <ReactPaginate
        previousLabel={''}
        nextLabel={''}
        pageCount={data.totalPages}
        activeClassName="active"
        forcePage={data.page !== 0 ? data.page - 1 : 0}
        onPageChange={(page) => handlePagination(page)}
        pageClassName={'page-item'}
        nextLinkClassName={'page-link'}
        nextClassName={'page-item next'}
        previousClassName={'page-item prev'}
        previousLinkClassName={'page-link'}
        pageLinkClassName={'page-link'}
        containerClassName={
          'pagination react-paginate justify-content-end my-2 pe-1'
        }
      />
    );
  };

  return (
    <Fragment>
      <Card className="overflow-hidden">
        <div className="react-dataTable">
          <DataTable
            noHeader
            subHeader
            sortServer
            pagination
            noDataComponent={<NoDataRecords />}
            responsive
            paginationServer
            columns={[...columns]}
            progressPending={loading}
            progressComponent={<ComponentSpinner />}
            sortIcon={<ChevronDown />}
            className="react-dataTable"
            paginationComponent={CustomPagination}
            data={store}
            subHeaderComponent={<HeaderRoads />}
          />
        </div>
      </Card>
    </Fragment>
  );
};

export default RoadsList;
